module.exports = __webpack_public_path__ + "img/login_popup.729c3baf.jpg";